<template>
  <div class="space-y-6" style="font-family: 'Inter', sans-serif;">
    <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
      <!-- BARRA DE FERRAMENTAS DA TABELA -->
      <div class="px-6 py-4 flex items-center justify-between" style="background-color: #333333;">
          <div class="flex items-center gap-3">
            <v-icon color="orange" small>mdi-handshake-outline</v-icon>
            <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">CONTRATOS VINCULADOS</h2>
          </div>
          
          <div class="flex items-center gap-4 flex-1 justify-end">
            <div class="flex-none">
              <button 
                @click="$router.push(`/biddings-contracts/create/${bidding_id}`)"
                class="bg-orange-500 hover:bg-orange-600 text-white shadow-lg flex items-center justify-center gap-2 rounded-lg px-6 py-2 transition-all w-fit max-w-max whitespace-nowrap"
              >
                <v-icon color="white" small>mdi-plus</v-icon>
                <span class="font-bold text-sm uppercase">NOVO CONTRATO</span>
              </button>
            </div>
            
            <div class="relative w-64">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <v-icon color="white" small class="opacity-50">mdi-magnify</v-icon>
              </div>
              <input 
                v-model="search"
                placeholder="PESQUISAR..."
                class="bg-white/10 border border-white/20 rounded-lg py-2 pl-10 pr-4 text-[10px] text-white placeholder:text-white/40 focus:outline-none focus:bg-white/20 transition-all w-full uppercase tracking-widest"
              >
            </div>
          </div>
      </div>

      <div class="p-0">
          <v-data-table
            :headers="headers"
            :items="data"
            :search="search"
            :items-per-page="10"
            :loading="loader"
            loading-text="CARREGANDO..."
            class="custom-table"
            hide-default-footer
          >
            <template v-slot:item.contract_value="{ item }">
              <span class="font-bold text-slate-700">R$ {{ realMask(formatCurrencyValue(item.contract_value)) }}</span>
            </template>
            <template v-slot:item.contract_start_term="{ item }">
              <span class="text-slate-500 font-medium">{{ item.contract_start_term && formatDateBr(item.contract_start_term) }}</span>
            </template>
            <template v-slot:item.contract_end_term="{ item }">
              <span class="text-slate-500 font-medium">{{ item.contract_end_term && formatDateBr(item.contract_end_term) }}</span>
            </template>
            <template v-slot:item.action="{ item }">
              <div class="flex justify-end gap-2">
                <button 
                  @click="$router.push(`/biddings-contracts/edit/${item.contract_id}/${bidding_id}`)"
                  class="p-2 hover:bg-orange-50 text-orange-600 rounded-lg transition-colors"
                  title="Editar"
                >
                  <v-icon small color="orange">mdi-pencil</v-icon>
                </button>
                <button 
                  @click="deleteItem(item.contract_id)"
                  class="p-2 hover:bg-red-50 text-red-600 rounded-lg transition-colors"
                  title="Excluir"
                >
                  <v-icon small color="red">mdi-delete</v-icon>
                </button>
              </div>
            </template>
          </v-data-table>
      </div>
    </section>

    <v-snackbar multi-line :color="snack.color" v-model="snack.show" transition="scroll-y-reverse-transition" class="mb-6">
      <div class="flex items-center gap-3">
        <v-icon color="white">mdi-information-outline</v-icon>
        <span class="font-bold text-xs uppercase tracking-wider text-white">{{ snack.message }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon small color="white">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: ["bidding_id", "prefecture_id"],
  data() {
    return {
      search: "",
      loader: true,
      showSearch: false,
      data: [],
      snack: {
        show: false,
        message: "",
        color: ""
      },
      headers: [
        {
          text: "Número",
          align: "start",
          sortable: false,
          value: "contract_number"
        },
        { text: "Licitaçāo", value: "bidding_process_number" },
        { text: "Participante", value: "provider_name" },
        { text: "Vl. do Contrato", value: "contract_value" },
        { text: "Data de Inicio", value: "contract_start_term" },
        { text: "Data de Termino", value: "contract_end_term" },
        { text: "Ações", align: "right", value: "action", sortable: false }
      ]
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    formatCurrencyValue(value) {
      const numericValue = Number(String(value ?? '').replace(',', '.'));
      if (Number.isNaN(numericValue)) {
        return '0.00';
      }
      return numericValue.toFixed(2);
    },
    realMask(value) {
      value = String(value ?? '0');
      value = value.replace(/\D/g, ""); // permite digitar apenas numero
      value = value.replace(/(\d{1})(\d{14})$/, "$1.$2"); // coloca ponto antes dos ultimos digitos
      value = value.replace(/(\d{1})(\d{11})$/, "$1.$2"); // coloca ponto antes dos ultimos 11 digitos
      value = value.replace(/(\d{1})(\d{8})$/, "$1.$2"); // coloca ponto antes dos ultimos 8 digitos
      value = value.replace(/(\d{1})(\d{5})$/, "$1.$2"); // coloca ponto antes dos ultimos 5 digitos
      value = value.replace(/(\d{1})(\d{1,2})$/, "$1,$2"); // coloca virgula antes dos ultimos 2 digitos
      return value;
    },
    formatDateBr(date) {
      return date
        .substr(0, 10)
        .split("-")
        .reverse()
        .join("/");
    },
    initialize() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(`/biddings/contracts/${this.bidding_id}`)
        .then(r => {
          this.data = r.data;
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch(e => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    deleteItem(id) {
      let c = confirm("Deseja excluir o registro?");
      if (c) {
        this.$store.dispatch("setLoader", true);
        this.$http
          .delete(`/biddings/contracts/${id}`)
          .then(r => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.snack.color = "success";
            this.initialize();
          })
          .catch(e => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.$store.dispatch("setLoader", false);
          });
      }
    }
  }
};
</script>

<style scoped>
.top-bar {
  padding: 30px 15px;
}
.title {
  text-transform: uppercase;
  font-weight: 400;
}
.maxPage {
  width: 100%;
}
.search-field {
  margin-top: 10px;
}
.space {
  margin: 0 10px;
}
.custom-table ::v-deep table thead th {
  background-color: #f8fafc !important;
  color: #64748b !important;
  font-size: 10px !important;
  font-weight: 800 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.1em !important;
  height: 48px !important;
  border-bottom: 1px solid #e2e8f0 !important;
}

.custom-table ::v-deep table tbody td {
  height: 60px !important;
  color: #334155 !important;
  border-bottom: 1px solid #f1f5f9 !important;
  font-size: 11px !important;
}

.bg-slate-700 { background-color: #333333 !important; }
.bg-slate-50 { background-color: #f8fafc !important; }
</style>
